const  EventBus = window.VueEventBus
import * as types from '../mutation-types/cart'

// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'Cart'

// state
const state = {
  isLocationCheckout: false,
  cartStep: 'cart',
  isValidating: false,
  validationError: null,
  valid: false,
  costDetails: null,
  askToSignIn: false,
  showCartInfoModal: false,
  cartInfoModalDetails: {},
  paymentDetails: {}
}

// mutations
const mutations = {
  [types.SET_CART_STEP](state, step) {
    state.cartStep = step
  },
  [types.SET_CART_VALID](state, valid) {
    state.valid = valid
  },
  [types.SET_CART_VALIDATING](state, status) {
    state.isValidating = status
  },
  [types.SET_VALIDATION_ERROR](state, message) {
    state.validationError = message
  },
  [types.SET_COST_DETAILS](state, payload) {
    state.costDetails = payload
  },
  [types.SET_SIGN_IN_FLAG](state, payload) {
    state.askToSignIn = payload
  },
  [types.SET_PAYMENT_DETAILS](state, payload) {
    state.paymentDetails = payload
  },
  [types.SET_LOCATION_CHECKOUT](state, allow = true) {
    state.isLocationCheckout = allow || false
  },
  [types.SHOW_CART_INFO_POPUP](state, payload) {
    if (!payload) {
      state.cartInfoModalDetails = {}
      state.showCartInfoModal = false
    } else {
      state.cartInfoModalDetails = payload
      state.showCartInfoModal = true
    }
  },
}

const actions = {
  setCartStep ({ commit }, payload) {
    commit(types.SET_CART_STEP, payload)
  },
  setCartValid ({ commit }, valid = true) {
    commit(types.SET_CART_VALID, valid)
  },
  setCartInvalid ({ commit }) {
    commit(types.SET_CART_VALID, false)
  },
  setCartValidating({ commit }, status = true) {
    commit(types.SET_CART_VALIDATING, status)
  },
  setValidationError ({ commit }, payload = null) {
    commit(types.SET_VALIDATION_ERROR, payload)
  },
  setCostDetails ({ commit }, payload) {
    commit(types.SET_COST_DETAILS, payload)
  },
  setAskToSignIn ({ commit }, payload) {
    commit(types.SET_SIGN_IN_FLAG, payload)
  },
  showCartInfo ({ commit }, payload) {
    commit(types.SHOW_CART_INFO_POPUP, payload)
  },
  hideCartInfo ({ commit }) {
    commit(types.SHOW_CART_INFO_POPUP, null)
  },
  setPaymentDetails({commit}, payload) {
    commit(types.SET_PAYMENT_DETAILS, payload)
  },
  allowLocationCheckout({commit}, allow = true) {
    commit(types.SET_LOCATION_CHECKOUT, allow)
  }
}

// getters
const getters = {
  cartStep: state => state.cartStep,
  isValidatingCart: state => state.isValidating,
  valid: state => state.valid,
  validationError: state => state.validationError,
  costDetails: state => state.costDetails,
  askToSignIn: state => state.askToSignIn,
  cartInfoModalDetails: state => state.cartInfoModalDetails,
  showCartInfoModal: state => state.showCartInfoModal,
  cartPaymentDetails: state => state.paymentDetails,
  useLocationCheckout: state => state.isLocationCheckout,
}

const cart = {namespaced, namespace, state, mutations, actions, getters}
export default cart
